/**
 * NAFA - Ajax Add to Cart Button
 * Gère l'ajout au panier sans rechargement de page
 */

(function() {
  'use strict';

  // Fonction pour ajouter au panier via AJAX
  async function addToCart(form, button) {
    // Désactiver le bouton pendant la requête
    button.setAttribute('aria-disabled', 'true');
    button.classList.remove('is-success'); // Retirer l'état précédent
    button.classList.add('is-loading');

    const formData = new FormData(form);
    
    // Récupérer les sections à mettre à jour
    const sectionsToUpdate = ['page-header', 'cart-drawer']
      .map(sel => document.querySelector(sel))
      .filter(el => el);
    const sectionIds = sectionsToUpdate.map(el => el.dataset.sectionId);

    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionIds.join(','));

    const fetchRequestOpts = {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    try {
      const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
      const data = await response.json();

      if (data.status) {
        // Erreur (stock insuffisant, etc.) - on reste normal, pas de rouge
        console.warn('Cart warning:', data.description || data.message);
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
        // Optionnel : afficher un message discret
      } else {
        // Succès - mettre à jour les sections
        if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
          sectionsToUpdate.forEach(el => {
            if (el.updateFromCartChange) {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            }
          });
        } else {
          // Fallback: déclencher un événement de changement
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        // Comportement après ajout selon les settings
        if (typeof theme !== 'undefined' && theme.settings) {
          if (theme.settings.afterAddToCart === 'drawer') {
            const cartDrawer = document.querySelector('.js-cart-drawer');
            if (cartDrawer && cartDrawer.open) {
              cartDrawer.open(button);
            }
          } else if (theme.settings.afterAddToCart === 'notification') {
            const notificationTemplate = document.getElementById('AddedNotification');
            if (notificationTemplate) {
              const notification = notificationTemplate.content.firstElementChild.cloneNode(true);
              notification.dataset.productTitle = data.product_title;
              let container = document.querySelector('.pageheader--sticky') || document.body;
              container.appendChild(notification);
            }
          }
        }

        // Animation de succès
        button.classList.remove('is-loading');
        button.classList.add('is-success');
        
        // Déclencher l'événement d'ajout
        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: data.variant_id }
        }));

        // Réactiver le bouton après l'animation de succès
        setTimeout(() => {
          button.removeAttribute('aria-disabled');
        }, 800);

        // Retirer l'état succès après un délai pour permettre un nouvel ajout
        setTimeout(() => {
          button.classList.remove('is-success');
        }, 1500);
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      // En cas d'erreur réseau, on retire juste le loading
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
    }
  }

  // Attacher les événements aux formulaires NAFA ATC
  function initNafaAtcForms() {
    document.querySelectorAll('.nafa-atc-form').forEach(form => {
      if (form.dataset.nafaAtcInit) return; // Déjà initialisé
      form.dataset.nafaAtcInit = 'true';

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const button = form.querySelector('.nafa-atc-button');
        if (button && button.getAttribute('aria-disabled') !== 'true') {
          addToCart(form, button);
        }
      });
    });
  }

  // Initialiser au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNafaAtcForms);
  } else {
    initNafaAtcForms();
  }

  // Réinitialiser lors de changements dynamiques (infinite scroll, etc.)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initNafaAtcForms();
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
